import {
  APIPostRequest,
  CheckoutAdyenPaymentResponse,
} from '@ancon/wildcat-types'

import Request from '../../client/Request'
import endpoints from '../endpoints'
import {
  CheckoutInvoicePaymentResponse,
  CheckoutSurfboardPaymentPayload,
  CheckoutSurfboardPaymentResponse,
} from '../../../features/checkout/types'
import {
  AdyenPaymentData,
  AdyenPaymentMethodsResponse,
} from '../../../features/adyen/types'

type PaymentsAPI = {
  post: {
    createAdyenPayment: APIPostRequest<
      CheckoutAdyenPaymentResponse,
      {
        paymentData: AdyenPaymentData
        companyId?: string
      },
      { outletId: string; checkoutId: string }
    >
    createSurfboardPayment: APIPostRequest<
      CheckoutSurfboardPaymentResponse,
      CheckoutSurfboardPaymentPayload,
      { outletId: string; checkoutId: string }
    >
    createInvoicePayment: APIPostRequest<
      CheckoutInvoicePaymentResponse,
      { companyId: string; invoiceReferenceNote: string },
      { outletId: string; checkoutId: string }
    >
    paymentMethods: APIPostRequest<
      AdyenPaymentMethodsResponse,
      {
        channel: string
        shopperLocale: string
      },
      { outletId: string; checkoutId: string }
    >
    details: APIPostRequest<
      CheckoutAdyenPaymentResponse,
      AdyenPaymentData,
      { outletId: string; checkoutId: string }
    >
  }
}

const payments: PaymentsAPI = {
  post: {
    createAdyenPayment: new Request(
      endpoints.core.outlets.byId.checkouts.byId.adyen.payments.list,
      { version: 1.2 },
    ).post,
    createSurfboardPayment: new Request(
      endpoints.core.outlets.byId.checkouts.byId.surfboard.payments.list,
      { version: 1.2 },
    ).post,
    createInvoicePayment: new Request(
      endpoints.core.outlets.byId.checkouts.byId.invoice.payments.list,
    ).post,
    paymentMethods: new Request(
      endpoints.core.outlets.byId.checkouts.byId.adyen.paymentMethods.list,
    ).post,
    details: new Request(
      endpoints.core.outlets.byId.checkouts.byId.adyen.paymentDetails.list,
      { version: 1.1 },
    ).post,
  },
}

export default payments
